/**
 * Achilles Size Select - Quick Add to Cart from Collection Grid
 */
window.AchillesSizeSelect = {
  /**
   * Handle size selection (called from inline onclick)
   */
  selectSize: function(sizeEl, event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    const variantId = sizeEl.dataset.variantId;
    if (!variantId) return;

    const wrapper = sizeEl.closest('.achilles-sizes-wrapper');
    if (!wrapper) return;

    // Deselect all other products
    document.querySelectorAll('.achilles-sizes-wrapper').forEach(function(w) {
      if (w !== wrapper) {
        w.querySelectorAll('.achilles-size--available').forEach(function(s) {
          s.classList.remove('is-selected');
        });
        var actions = w.querySelector('[data-size-actions]');
        if (actions) actions.classList.remove('is-visible');
      }
    });

    // Toggle this size
    var wasSelected = sizeEl.classList.contains('is-selected');

    // Deselect all in this wrapper
    wrapper.querySelectorAll('.achilles-size--available').forEach(function(s) {
      s.classList.remove('is-selected');
    });

    var actionsContainer = wrapper.querySelector('[data-size-actions]');
    var addToCartBtn = wrapper.querySelector('[data-add-to-cart]');

    if (wasSelected) {
      // Deselect
      if (actionsContainer) actionsContainer.classList.remove('is-visible');
      if (addToCartBtn) {
        addToCartBtn.disabled = true;
        addToCartBtn.dataset.variantId = '';
      }
    } else {
      // Select
      sizeEl.classList.add('is-selected');
      if (actionsContainer) actionsContainer.classList.add('is-visible');
      if (addToCartBtn) {
        addToCartBtn.disabled = false;
        addToCartBtn.dataset.variantId = variantId;
      }
    }
  },

  /**
   * Handle Add to Cart
   */
  addToCart: function(btn, event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    var variantId = btn.dataset.variantId;
    if (!variantId || btn.disabled) return;

    // Loading state
    btn.classList.add('is-loading');
    btn.disabled = true;

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(function(response) {
      if (!response.ok) {
        return response.json().then(function(data) {
          throw new Error(data.description || 'Error adding to cart');
        });
      }
      return response.json();
    })
    .then(function() {
      // Success - open cart drawer
      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));

      // Reset selection
      setTimeout(function() {
        document.querySelectorAll('.achilles-size--available.is-selected').forEach(function(s) {
          s.classList.remove('is-selected');
        });
        document.querySelectorAll('[data-size-actions].is-visible').forEach(function(a) {
          a.classList.remove('is-visible');
        });
      }, 300);
    })
    .catch(function(error) {
      console.error('Add to cart error:', error);
      var textEl = btn.querySelector('.achilles-size-actions__atc-text');
      if (textEl) {
        var original = textEl.textContent;
        textEl.textContent = error.message || 'Error';
        btn.style.borderColor = '#c00';
        btn.style.color = '#c00';
        setTimeout(function() {
          textEl.textContent = original;
          btn.style.borderColor = '';
          btn.style.color = '';
        }, 2500);
      }
    })
    .finally(function() {
      btn.classList.remove('is-loading');
      btn.disabled = false;
    });
  }
};
